<template>
    <div class="body" id="joinUp">
        <div class="head">学校物联网智能接入中心
            <!--<div class="login_user" v-on:click="show = !show" :style="nickname=='请登录'||name=='请登录'?'color:#F06B34':'' ">-->
                <!--{{nickname||name}}-->
                <!--<em title="切换登录" v-if="nickname!='请登录'||name!='请登录'"></em>-->
            <!--</div>-->
        </div>
        <div class="box">
            <div class="box-l">
                <div class="box-lt box-border">
                    <div>
                        <div class="screen-title">基本情况</div>
                        <div class="box-lt-c">
                            <div>
                                <div>校区数</div>
                                <div>{{essentialObj.campusNum||0}}个</div>
                            </div>
                            <div>
                                <div>学生人数</div>
                                <div>{{essentialObj.studentCount||0}}</div>
                            </div>
                            <div>
                                <div>教师人数</div>
                                <div>{{essentialObj.teacherCount||0}}</div>
                            </div>
                            <div>
                                <div>人脸验证</div>
                                <div>{{essentialObj.faceCount||0}}</div>
                            </div>
                            <div>
                                <div>卡用户</div>
                                <div>{{essentialObj.cardCount}}个</div>
                            </div>
                            <div>
                                <div>班级数</div>
                                <div>{{essentialObj.classCount||0}}</div>
                            </div>
                            <div>
                                <div>宿舍数</div>
                                <div>{{essentialObj.dormitoryCount||0}}</div>
                            </div>
                            <div>
                                <div>食堂窗口</div>
                                <div>0</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-lc box-border">
                    <div class="table">
                        <div class="screen-title">设备智联情况</div>
                        <div class="box-table">
                            <div class="table-title">
                                <p>设备类别</p>
                                <p>数量</p>
                                <p>联网率</p>
                                <p>远程控制</p>
                            </div>
                            <div class="tip" v-if="deviceList.length==0">暂无数据</div>
                            <div class="table-main-box">
                                <div class="table-box scrollTable" :style="{top: tableTop1 + 'px'}">
                                    <div v-for="(item,index) in deviceList" :key="index">
                                        <p>{{item.name}}</p>
                                        <p>{{item.num}}</p>
                                        <p>{{item.value}}%</p>
                                        <p>{{item.networking||0}}%</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-lb box-border">
                    <div class="echart">
                        <div class="screen-title">统计图</div>
                        <div id="myEcharts1" class="statics"></div>
                    </div>
                </div>
            </div>
            <div class="box-c">
                <div class="box-ct">
                    <div class="video-tip" v-if="deviceTypeList.length==0">暂无设备</div>
                    <div class="box-ct-title">
                        <div v-for="(item,index) in deviceTypeList" :key="index"
                             :class="active==item.deviceId?'actived':''" @click="videoChange(item)">
                            {{item.name}}
                        </div>
                    </div>
                    <video id="video" autoplay v-if="deviceTypeList.length!==0"></video>
                </div>
                <div class="box-cb box-border">
                    <div class="echart">
                        <div class="screen-title">设备使用情况</div>
                        <div id="myEcharts2" class="statics"></div>
                    </div>
                </div>
            </div>
            <div class="box-r">
                <div class="box-rt box-border">
                    <div class="table">
                        <div class="screen-title">今日运行情况</div>
                        <div class="box-table">
                            <div class="table-title">
                                <p>设备类别</p>
                                <p>设备码</p>
                                <p>运行时长</p>
                                <p>工作时段</p>
                            </div>
                            <div class="tip" v-if="operationList.length==0">暂无数据</div>
                            <div class="table-main-box">
                                <div class="table-box scrollTable" :style="{top: tableTop + 'px'}">
                                    <div v-for="(item,index) in operationList" :key="index">
                                        <p>{{item.name}}</p>
                                        <p>{{item.code}}</p>
                                        <p>{{item.onlineDistance}}</p>
                                        <p>{{item.time}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-rb box-border">
                    <div class="table">
                        <div class="screen-title">综合警告</div>
                        <div class="box-table warn">
                            <div class="table-title">
                                <div>告警类型</div>
                                <div>告警位置</div>
                                <div class="warn-content" style="text-align: center !important">告警内容</div>
                            </div>
                            <div class="tip" v-if="alarmList.length==0">暂无数据</div>
                            <div class="table-warn-box">
                                <div class="table-box warn-box">
                                    <div v-for="(item,index) in alarmList" :key="index">
                                        <div class="ellipsis">{{item.type}}</div>
                                        <div class="ellipsis">{{item.location}}</div>
                                        <div class="warn-content">
                    <span>
                      {{item.content}}
                    </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="bounce">
            <div class="mask" v-show="show">
                <div class="screen_login">
                    <img src="../../assets/imgs/logo.png" width="72">
                    <em class="guanbi" @click="show = !show">✖</em>
                    <i>易校园魔方</i>
                    <input placeholder="手机号/帐号名" :class="loginForm.error1?'error':''" v-model="loginForm.username"
                           name="username"
                           v-on:input="onchanges"/>
                    <input type="password" placeholder="请输入密码" :class="loginForm.error1?'error':''"
                           v-model="loginForm.password"
                           name="password" v-on:input="onchanges"/>
                    <p :class="loginForm.error?'error':''">{{ loginForm.message }}</p>
                    <span @click="login()">登录</span>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "joinUpLargeScreen",
        data() {
            return {
                query:{
                    schoolId:'',
                    openid: 'abc',
                },

                fullscreen: false,
                myCharts1: null,
                myCharts2: null,
                essentialObj: {},
                deviceList: [],
                operationList: [],
                visibleSize: 9, //容器内可视最大完整行数
                lineHeight: 40, //每行的实际高度
                tableTimerInterval: 100, //向上滚动 1px 所需要的时间
                tableTimer: null,
                tableTimer1: null,
                tableTop: 0,
                tableTop1: 0,

                alarmList: [],
                webRtcServer: null,
                deviceTypeList: [],
                active: '',

                loginForm: {
                    username: '',
                    password: '',
                    message: '',
                    error: false,
                    error1: false
                },
                name: localStorage.getItem('name') ? localStorage.getItem('name') : '请登录',
                nickname: localStorage.getItem('nickname') ? localStorage.getItem('nickname') : '请登录',
                show: false,

            }
        },
        created() {
            this.query.schoolId=this.$route.query.schoolId
        },
        mounted() {
            // if (this.name != '请登录' || this.nickname != '请登录') {
                this.funAll()
            // }
        },

        beforeDestroy() {
            this.webRtcServer.disconnect()
            this.webRtcServer = null
        },
        methods: {
            funAll() {
                this.getEssential(); //基本情况
                this.getDeviceChart(); //设备智联情况
                this.getOperation(); //今日运行情况
                this.getDeviceUseChart(); //设备使用情况
                this.getAlarm(); //综合警告
                this.getFindByDeviceTypeId(); //视频
                this.getStatistical() //统计图
                window.onresize = () => {
                    this.myCharts1.resize();
                    this.myCharts2.resize();
                };
            },
            // 基本情况
            getEssential() {
                let url = "/front/bp/internet/essential"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let json = response.data
                        this.essentialObj = json.data
                    }
                })
            },
            //设备智联情况
            getDeviceChart() {
                clearInterval(this.tableTimer1);
                this.tableTop1 = 0
                let url = "/front/bp/internet/deviceChart"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let json = response.data
                        this.deviceList = json.data
                        this.tablDeviceFun()
                    }
                })
            },
            tablDeviceFun() {
                this.deviceListSize = this.deviceList.length;
                if (this.deviceListSize > this.visibleSize) {
                    this.deviceList = this.deviceList.concat(this.deviceList);
                    this.tableTimerFun1();
                }
            },
            tableTimerFun1() {
                var count = 0;
                this.tableTimer1 = setInterval(() => {
                    if (count < (this.deviceList.length / 2) * this.lineHeight) {
                        this.tableTop1 -= 1;
                        count++;
                    } else {
                        count = 0;
                        this.tableTop1 = 0;
                    }
                }, this.tableTimerInterval);
            },
            //今日运行情况
            getOperation() {
                clearInterval(this.tableTimer);
                this.tableTop = 0
                let url = "/front/bp/internet/operation"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let json = response.data
                        this.operationList = json.data
                        this.tableOperationFun()
                    }
                })
            },

            tableOperationFun() {
                this.operationListSize = this.operationList.length;
                if (this.operationListSize > this.visibleSize) {
                    this.operationList = this.operationList.concat(this.operationList);
                    this.tableTimerFun();
                }
            },
            tableTimerFun() {
                var count = 0;
                this.tableTimer = setInterval(() => {
                    if (count < (this.operationList.length / 2) * this.lineHeight) {
                        this.tableTop -= 1;
                        count++;
                    } else {
                        count = 0;
                        this.tableTop = 0;
                    }
                }, this.tableTimerInterval);
            },

            //设备使用情况
            getDeviceUseChart() {
                let url = "/front/bp/internet/deviceUseChart"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data || []
                        let x = datas.x || []
                        let y = datas.y || []
                        let arr = [[], [], []]

                        y.map(item => {
                            arr[0].push(item[0] || 0)
                            arr[1].push(item[1] || 0)
                            arr[2].push(item[2] || 0)
                        })
                        this.serviceCondition(x, arr)
                    }
                })
            },
            getFindByDeviceTypeId() {
                let url = "/front/bp/internet/findByDeviceTypeId"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        this.deviceTypeList = response.data.data || []
                        if (this.deviceTypeList.length == 0) return
                        this.videoChange(this.deviceTypeList[0])
                    }
                })
            },
            videoChange(item) {
                console.log(item.rtspHost || '127.0.0.1:8000')
                this.active = item.deviceId
                // this.webRtcServer = new WebRtcStreamer('video', location.protocol + '//127.0.0.1:8000')

                this.webRtcServer = new WebRtcStreamer('video', location.protocol + '//' + (item.rtspHost || '127.0.0.1:8000'))
                //需要查看的rtsp地址
                let resp = "rtsp://admin:" + (item.password || 123456) + "@" + item.host + ":554/mpeg4/ch01/main/av_stream"
                this.webRtcServer.connect(resp || '')
            },

            //使用情况
            serviceCondition(x, y) {
                let datas = [];
                y.map(item => {
                    datas.push(item.map(v => {
                        return (Math.sqrt(v)).toFixed(0);
                    }))
                })
                this.myCharts2 = this.$echarts.init(document.getElementById('myEcharts2'))
                // 绘制图表

                this.myCharts2.setOption({
                    color: ['#11EBFA', '#FDA026', '#FF0025'],
                    legend: {
                        data: ['今日', '平均', '最高'],
                        textStyle: {
                            color: '#ffffff'
                        },
                        left: 'right'
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '0%',
                        containLabel: true
                    },
                    yAxis: {
                        show: false,
                        type: 'value',
                        boundaryGap: [0, 0.01]
                    },
                    xAxis: {
                        type: 'category',
                        data: x,
                        axisLabel: {
                            textStyle: {
                                color: 'white'
                            }
                        }
                    },
                    series: [
                        {
                            name: '今日',
                            type: 'bar',
                            data: datas[0],
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        position: 'top',
                                        formatter: (params => {
                                            return y[0][params.dataIndex]
                                        }),
                                    }
                                }
                            }
                        },
                        {
                            name: '平均',
                            type: 'bar',
                            data: datas[1],
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        position: 'top',
                                        formatter: (params => {
                                            return y[1][params.dataIndex]
                                        }),
                                    }
                                }
                            }
                        },
                        {
                            name: '最高',
                            type: 'bar',
                            data: datas[2],
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        position: 'top',
                                        formatter: (params => {
                                            return y[2][params.dataIndex]
                                        }),
                                    }
                                }
                            }
                        },
                    ]
                })
            },
            // 综合警告
            getAlarm() {
                let url = "/front/bp/internet/alarm"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data || []
                        this.alarmList = datas
                    }
                })
            },
            getStatistical() {
                let url = "/front/bp/internet/statistical"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data
                        let x = datas.x || []
                        let y = datas.y || []
                        this.statistics(x, y)
                    }
                })
            },
            //统计图
            statistics(x, y) {
                this.myCharts1 = this.$echarts.init(document.getElementById('myEcharts1'))
                // 绘制图表
                this.myCharts1.setOption({
                    color: ['#FDA026'],
                    legend: {
                        itemWidth: 15,
                        itemHeight: 10,
                        right: 0,
                        data: ['终端接入'],
                        textStyle: {
                            color: "#FDA026",
                        },
                    },
                    radar: {
                        radius: '60%',
                        splitNumber: 4, // 雷达图圈数设置
                        center: ['50%', 80],
                        indicator: [
                            {name: '实时联网', max: 100},
                            {name: '远程管理', max: 100},
                            {name: '数据实时上报', max: 100},
                            {name: '阈值预警', max: 100},
                            {name: '智能识别', max: 100},
                        ],
                    },
                    series: [
                        {
                            type: 'radar',
                            data: [
                                {
                                    value: y,
                                    name: '终端接入',
                                },
                            ]
                        }
                    ]
                })
            },

            onchanges(e) {
                this.loginForm.message = ''
                this.loginForm.error = false
                this.loginForm.error1 = false
            },
            login() {
                let _this = this
                let accountName = _this.loginForm.username;
                let password = _this.$md5(_this.loginForm.password);
                if (accountName.length == 0) {
                    _this.loginForm.message = '用户名/密码不可为空'
                    _this.loginForm.error = true
                    _this.loginForm.error1 = true
                    return
                }
                if (password.length == 0) {
                    _this.loginForm.message = '用户名/密码不可为空'
                    _this.loginForm.error = true
                    _this.loginForm.error1 = true
                    return
                }
                let url = "/zuHu/api-platform/auth/login"
                let params = {
                    vType: 2,
                    accountName: accountName,
                    password: password
                }
                this.$api.post(url, params, response => {
                    let data = response
                    if (data.data.result == 'success') {
                        localStorage.setItem('token', data.data.token);
                        localStorage.setItem('name', data.data.name);
                        localStorage.setItem('nickname', data.data.nickname);
                        this.$message({
                            type: 'success',
                            message: '登录成功'
                        });
                        setTimeout(function () {
                            // location.reload()
                            _this.show = false
                            _this.funAll()
                        }, 800)
                    } else {
                        this.$message.error(data.data.message);
                        _this.loginForm.message = 'data.data.message'
                        _this.loginForm.error = true
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .body {
        width: 100%;
        /*height: 1080px;*/
        height: 100%;
        background: rgb(3, 17, 51);
        overflow: hidden;
    }

    .head {
        height: 120px;
        color: white;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 38px;
        position: relative;
        background: url("../../assets/imgs/top.jpg") no-repeat center 0;
        box-sizing: border-box;
        position: relative;
    }

    .fullScreen {
        position: absolute;
        cursor: pointer;
        top: -10px;
        right: 10px;
    }

    .fullScreen .icon {
        font-size: 22px;
    }

    .box {
        display: flex;
        /*height: 960px;*/
        height: calc(100% - 120px);
    }

    .box > div {
        padding: 10px 0 0;
    }

    .box > div > div {
        width: 90%;
        margin: 0 auto 20px;
    }

    .box-l, .box-r {
        width: 25%;
    }

    .box-l > div, .box-r > div {
        background: rgb(5, 19, 38);
    }

    .box-c {
        background: rgb(0, 2, 41);
        flex: 1;
    }

    .screen-title {
        color: #4BE6FF;
        font-weight: bold;
        font-size: 16px;
        padding: 20px 30px;
    }

    .box-border {
        position: relative;
    }

    .box-border::before {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 10px;
        height: 10px;
        border-left: 2px solid #00CDF4;
        border-bottom: 2px solid #00CDF4;
        content: "";
        border-bottom-left-radius: 5px;
        z-index: 10;
    }

    .box-border::after {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 10px;
        height: 10px;
        border-right: 2px solid #00CDF4;
        border-bottom: 2px solid #00CDF4;
        content: "";
        border-bottom-right-radius: 5px;
        z-index: 10;
    }

    .box-border > div::before {
        position: absolute;
        top: 0;
        left: 0;
        width: 10px;
        height: 10px;
        border-left: 2px solid #00CDF4;
        border-top: 2px solid #00CDF4;
        content: "";
        border-top-left-radius: 5px;
        z-index: 10;
    }

    .box-border > div::after {
        position: absolute;
        top: 0;
        right: 0;
        width: 10px;
        height: 10px;
        border-right: 2px solid #00CDF4;
        border-top: 2px solid #00CDF4;
        content: "";
        border-top-right-radius: 5px;
        z-index: 10;
    }

    .box-lt {
        height: 20%;
        min-height: 180px;
    }

    .box-lt-c {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .box-lt-c > div {
        width: 22%;
        color: rgb(66, 133, 183);
        text-align: center;
        margin-bottom: 20px;
    }

    .box-lt-c > div > div:first-child {
        font-size: 14px;
        padding: 0 0 5px;
        font-weight: bold;
    }

    .box-lt-c > div > div:last-child {
        font-size: 16px;
        font-weight: bold;
        color: rgb(167, 176, 238);
    }

    .box-lc {
        height: calc(50% - 40px);
    }

    .box-lb {
        height: 25%;
    }

    .table {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .box-table {
        position: relative;
        flex: 1;
        overflow: hidden;
    }

    .table-title {
        font-size: 16px;
        color: rgb(66, 133, 183);
        display: flex;
        justify-content: space-between;
        position: sticky;
        top: 0;
        background: rgb(5, 19, 38);
    }

    .table-title p {
        width: 25%;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }

    .table-main-box {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }

    .scrollTable {
        width: 100%;
        position: absolute;
        left: 0;
    }

    .table-box > div {
        display: flex;
        color: rgb(229, 238, 227);
        justify-content: space-between;
    }

    .table-box > div:nth-child(odd) {
        background: rgb(17, 33, 62);
    }

    .table-box > div > p {
        width: 25%;
        text-align: center;
        height: 40px;
        line-height: 40px;
        white-space: nowrap;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .statics {
        width: 100%;
        height: 150px
    }

    .box-ct {
        height: calc(70% - 20px);
        margin-bottom: 20px;
        /*border: 1px solid red;*/
        position: relative;
    }

    .box-ct-title {
        color: white;
        position: absolute;
        z-index: 999;
        display: flex;
    }

    .box-ct-title > div {
        border: 1px solid rgb(0, 118, 194);
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        padding: 10px 20px;
        cursor: pointer;
    }

    .box-ct-title > div:first-child {
        border-bottom-left-radius: 40px;
        border-top-left-radius: 40px;
    }

    .box-ct-title > div:last-child {
        border-bottom-right-radius: 40px;
        border-top-right-radius: 40px;
    }

    .box-ct video {
        width: 100%;
        height: 100%;
    }

    .box-cb {
        height: 25%;
    }

    .box-rt {
        height: calc(50% - 40px);
    }

    .box-rb {
        height: calc(45% + 20px);
    }

    .warn .ellipsis {
        white-space: nowrap;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .warn > div div {
        flex: 1;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }

    .warn-content {
        flex: 2 !important;
        overflow: hidden;
        position: relative;
        /*text-align: left !important;*/
    }

    .warn-content > span {
        white-space: nowrap;
        /*animation: 15s wordsLoop linear infinite normal;*/
        display: inline-block;
        text-align: left;
        /*text-align: center;*/
    }

    @keyframes wordsLoop {
        0% {
            transform: translateX(0px);
            -webkit-transform: translateX(0px);
        }
        100% {
            transform: translateX(-100%);
            -webkit-transform: translateX(-100%);
        }
    }

    .echart {
        height: 100%;
    }

    .echart > div:nth-child(2) {
        height: calc(100% - 60px);
    }

    .actived {
        background-image: linear-gradient(rgb(0, 160, 177), rgb(0, 93, 171));
    }

    .table-warn-box {
        width: 100%;
        height: 100%;
        overflow: auto;
    }

    .table-warn-box::-webkit-scrollbar {
        width: 4px;
    }

    .table-warn-box::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        opacity: 0.2;
        background: rgba(120, 229, 250, 1);
    }

    .table-warn-box::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(120, 229, 250, 0.6);
    }

    .tip {
        width: 100%;
        font-size: 18px;
        color: gray;
        text-align: center;
        padding: 20px 0;
    }

    .video-tip {
        color: gray;
        font-size: 18px;
        width: 100%;
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .login_user {
        font-size: 26px;
        position: absolute;
        top: 50px;
        right: 20px;
    }

    .login_user em {
        width: 27px;
        height: 27px;
        display: inline-block;
        cursor: pointer;
        background: url("../../assets/imgs/replace.png") no-repeat center/100%;
        vertical-align: middle;
    }

    /*登录*/
    .screen_login {
        width: 327px;
        height: 417px;
        background: url("../../assets/imgs/login_bg.png") no-repeat center 0;
        padding: 60px 48px 38px 24px;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -271px;
        margin-left: -210px;
    }

    .screen_login img {
        margin-top: 12px;
        margin-bottom: 12px;
    }

    .screen_login i {
        font-size: 36px;
        font-family: 隶书;
        color: white;
        margin-bottom: 35px;
        font-style: normal;
        display: block;
    }

    .screen_login input {
        width: 246px;
        height: 32px;
        border: 1px solid #003366;
        font-size: 16px;
        padding: 5px 12px;
        line-height: 32px;
        background: #003366;
        border-radius: 21px;
        color: #00CCCC;
        margin-bottom: 5px;
        margin-top: 18px;
        box-shadow: 0 3px 6px rgba(51, 255, 255, .3), 3px 0 6px rgba(51, 255, 255, .3);
    }

    .screen_login input:focus {
        outline: none;
        border: 1px solid #009900;
    }

    .screen_login input::-webkit-input-placeholder {
        color: #fff;
    }

    .screen_login input.error {
        border: 1px solid #ff0000;
        background: #FFCCCC;
        color: #ff0000;
        box-shadow: 0 3px 6px rgba(255, 51, 102, .3), 3px 0 6px rgba(255, 51, 102, .3);
    }

    .screen_login p {
        font-size: 12px;
        color: #00CCCC;
        padding-left: 35px;
        text-align: left;
    }

    .screen_login p.error {
        color: #ff0000;
        text-shadow: 1px 0px 2px rgba(0, 0, 0, .7);
    }

    .screen_login span {
        width: 270px;
        height: 40px;
        line-height: 40px;
        color: white;
        font-size: 16px;
        border-radius: 20px;
        background-image: linear-gradient(to right, #3366FF, #33FFFF);
        text-shadow: 3px 1px 5px rgba(0, 0, 0, 0.6);
        display: inline-block;
        margin-top: 28px;
        cursor: pointer;
    }

    .screen_login span:hover {
        background-image: linear-gradient(to right, #0033FF, #33FFFF);
    }

    .screen_login span:active {
        background-image: linear-gradient(to bottom, #3366FF, #33FFFF);
    }

    .screen_login .guanbi {
        right: 50px;
        top: 62px;
        background: rgba(0, 153, 204, 0.53);
        color: white;
    }

    .guanbi {
        width: 35px;
        height: 35px;
        box-shadow: 2px 1px 2px rgba(0, 0, 0, 0.35);
        border-radius: 50%;
        position: absolute;
        top: 6px;
        right: 8px;
        line-height: 35px;
        font-style: normal;
        color: #006600;
        cursor: pointer;
    }

    .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        z-index: 999;
    }
</style>
